<template>
  <div class="hvh-flex wrap" @click.stop="focus">
    <CohortSearchPill class="pill-margin" :item="item" @click="$emit('item-clicked', item)" @remove="$emit('remove', item)" v-for="item in selectedItems || []" :key="`criteria-${item.search}`" />
    <DPDSingleSelectInput
      :value="value"
      :style="inputStyle"
      :placeholder="!hasItems && placeholder"
      @input="$emit('input', $event)"
      @paste="$emit('paste', $event)"
      @focus="$emit('focus', $event)"
      @mousedown="$emit('mousedown', $event)"
      @keydown="$emit('keydown', $event)"
      ref="input"
    />
  </div>
</template>

<script>
import { getTextWidth } from '../../../../libraries/common';
import CohortSearchPill from '../../../analytics/cohorts/CohortSearchPill.vue';
import DPDSingleSelectInput from './DPDSingleSelectInput.vue';
export default {
  noExport: true,
  components: { CohortSearchPill, DPDSingleSelectInput },
  props: ['value', 'selectedItems', 'placeholder'],
  data() {
    return {
      inputFont: null,
    };
  },
  computed: {
    hasItems() {
      return (this.selectedItems || []).any();
    },
    inputStyle() {
      var textWidth = getTextWidth(this.inputFont)(this.value || '');
      return { width: this.hasItems ? `${textWidth + 30}px` : '100%' };
    },
  },
  methods: {
    focus() {
      this.$refs.input.$el.focus();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisMultiSelectInput'] = this;

    this.inputFont = getComputedStyle(this.$refs.input.$el).font;
  }
}
</script>
